import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'

Vue.use(Vuex)

// var URL = 'http://localhost:5005/'
var URL = 'https://server-web.konaweselatankab.go.id/'

export default new Vuex.Store({
  state: {
    coordinat : {
      lat:-4.034694, 
      lng: 122.484263
    },
    btn : {
      add : false,
      edit : false,
      remove : false,
    },
    url : {
      URL_APP : URL,

      URL_BERITA : URL+'api/v1/web_berita/',
      URL_KATEGORI_BERITA : URL+'api/v1/web_publish_kategori/',
      URL_DATA_PEGAWAI : URL+'api/v1/serverDpmptspDataPegawai/',
      URL_PROFIL_KANTOR : URL+'api/v1/server_dpmptsp_profil/',
      URL_STRUKTUR_ORGANISASI : URL+'api/v1/server_dpmptsp_struktur_organisasi/',
      URL_TUGAS_POKOK : URL+'api/v1/server_dpmptsp_tugas_pokok/',
      URL_VISI_MISI : URL+'api/v1/server_dpmptsp_visi_misi/',
      URL_PETA : URL+'api/v1/server_dpmptsp_peta/',
      URL_POTENSI : URL+'api/v1/server_dpmptsp_potensi/',
      URL_WILAYAH : URL+'api/v1/wilayah_kecamatan/',
      URL_FAQ : URL+'api/v1/server_dpmptsp_faq/',
      URL_DASHBOARD : URL+'api/v1/dashboard/',

      checkAuth : URL + 'api/v1/checkAuth/',
    },

    list_menu : null,
    aksesMenu : {},
    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,

    list_kecamatan : [],
    list_des_kel : [],
    list_kbli : [],

    type : [
      {id : 0, uraian : 'Single Menu'},
      {id : 1, uraian : 'Multy Menu'}
    ],

    
  },
  mutations: {
    listJeniskategorilokasi(state){

      fetch(state.url.URL_MasterKategoriLokasi, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          state.list_MasterKategoriLokasi = res_data;
      });

    },

    listApelJenis(state){

      fetch(state.url.URL_apelJenis, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          // console.log(res_data)
          state.list_ApleJenis = res_data;
      });

    },

    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'yellow',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
